/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1LocationCitiesDropdown200,
  GetApiV1LocationCitiesDropdown401,
  GetApiV1LocationCitiesDropdown500,
  GetApiV1LocationCitiesDropdownQueryParams,
  GetApiV1LocationCitiesDropdownQueryResponse,
} from "../../types/locationCityController/GetApiV1LocationCitiesDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1LocationCitiesDropdownQueryParamsSchema = z
  .object({
    stateId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1LocationCitiesDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1LocationCitiesDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1LocationCitiesDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1LocationCitiesDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCitiesDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1LocationCitiesDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1LocationCitiesDropdown500>;

export const getApiV1LocationCitiesDropdownQueryResponseSchema = z.lazy(
  () => getApiV1LocationCitiesDropdown200Schema,
) as unknown as ToZod<GetApiV1LocationCitiesDropdownQueryResponse>;
